import classNames from 'classnames';
import { FunctionComponent, memo } from 'react';
import { Event, EventStatus } from '../../../services';
import { isEventPast } from '../../utils';
import { EventItemContent } from './EventItemContent';

import classes from './EventItem.module.scss';

interface EventItemProps {
  event: Event;
}

export const EventItem: FunctionComponent<EventItemProps> = memo(({ event }) => {
  const { startAt, endAt, status } = event;

  return (
    <div
      className={classNames(classes['event'], {
        [classes['event--inactive']]:
          status === EventStatus.CANCELLED || isEventPast(startAt, endAt),
      })}
    >
      <EventItemContent event={event} showDescription showViewLink />
    </div>
  );
});
